import { FC, useMemo } from 'react'

import { Typography } from '@mui/material'

import { MaskedTextGuard } from '../../../../../../../components/MaskedTextGuard/MaskedTextGuard'
import languageService from '../../../../../../../services/LanguageService'
import { LiveEventCompactTrail } from '../../../../../../live-events/components/LiveEventCompactTrail/LiveEventCompactTrail'
import { EventDialogTab } from '../../../../../../live-events/hooks/useEventDialogTabs'
import { useLiveEventModal } from '../../../../../../live-events/hooks/useLiveEventModal'
import { useNewsEntryLiveEventBlueprint } from '../../../../../hooks/useNewsEntryLiveEventBlueprint'
import { UnifiedNewsEntry } from '../../../../../types/UnifiedNewsEntry'
import { getLiveEventDialogConfig } from '../../../../../utils/utils'
import { LiveEventSubHeader } from '../LiveEventSubHeader'

type LiveEventNewEventSubHeaderProps = {
  newsEntry: UnifiedNewsEntry
  showLimitedContent?: boolean
}

export const LiveEventNewEventSubHeader: FC<LiveEventNewEventSubHeaderProps> = ({ newsEntry, showLimitedContent }) => {
  // const hasAccessToLiveEventsTracker = useLiveEventsTrackerAccessCheck()
  const { showModal: showEventModal } = useLiveEventModal()
  const handleClick = () => {
    showEventModal({ ...getLiveEventDialogConfig(newsEntry), tab: EventDialogTab.Description })
  }

  const startDate = useMemo(() => {
    return newsEntry.feedEntry.entryData.durations?.reduce((acc, duration) => {
      if (!acc || duration.start < acc) {
        return duration.start
      }
      return acc
    }, 0)
  }, [newsEntry.feedEntry.entryData.durations])

  const eventTypeId = newsEntry.feedEntry.entryData.typeId
  const liveEventTypeName = languageService.getTranslation('tags', eventTypeId)
  // The event's place in the live event taxonomy, with links into Live Event
  // Analytics (same trail as the LET feed card and the calendar popup). Limited
  // content keeps the masked type name and skips the lookups behind the trail.
  const { trackedGame, gameLevelBlueprintId } = useNewsEntryLiveEventBlueprint(newsEntry, !showLimitedContent)

  return (
    <LiveEventSubHeader
      linkLabel={newsEntry.feedEntry.subtitle}
      date={startDate}
      onLinkClick={showLimitedContent ? undefined : handleClick}
      showLimitedContent={showLimitedContent}
    >
      {showLimitedContent ? (
        <Typography variant="body1">
          <MaskedTextGuard reveal={false} text={liveEventTypeName} length={20} />
        </Typography>
      ) : (
        <LiveEventCompactTrail eventTypeId={eventTypeId} trackedGame={trackedGame} gameLevelBlueprintId={gameLevelBlueprintId} variant="body1" openInNewTab />
      )}
    </LiveEventSubHeader>
  )
}
